<div class="interactive-chart-container">
  <div class="chart-header">
    <div class="chart-controls">
      <button
        type="button"
        class="reset-zoom-btn"
        (click)="resetZoom()"
        title="Réinitialiser le zoom"
        *ngIf="displayonReset"
      >
        <i class="pi pi-refresh"></i>
        Rafraîchir
      </button>
      <div class="zoom-instructions">
        <i class="pi pi-info-circle"></i>
        <span>Molette: zoom | Glisser: déplacer</span>
      </div>
    </div>
  </div>

  <div class="chart-wrapper" [style.height.px]="height">
    <canvas
      baseChart
      [data]="datasets"
      [options]="chartOptions"
      [plugins]="additionalPlugins"
      [type]="'line'"
      [height]="height"
    >
    </canvas>
  </div>
</div>
